<template>
  <div>
    
    <div class="text-black bg-white pt-5 pb-5">
      <div class="container">
        <div class="h1">Registrazione</div>
        <div>
          <br />E' possibile inserire sulla mappa la posizione della propria attività.
          <br />In pochi semplici passi è possibile registrarsi online, aumentare la tua visibilità e la possibilità di essere notato.
          <br />Potrai in questo modo essere trovato facilmente e restare in contatto con i clienti tramite i canali che indicherai: Facebook, Telegram, Whatsapp, telefono, email.
        </div>
      </div>
    </div>

    <div class="bg-light">
      <div class="container d-none d-sm-block">
        <div class="row pt-5 pb-5">
          <div class="col-8 text-left align-self-center">
            <div class="h3">Vogliamo aiutare le aziende della nostra valle, noi ci crediamo. E tu?</div>
            <div class="row mt-4">
              <div class="col-4 mr-4 pr-0">
                <b-button variant="dark" class="text-white btn-style" to="/registrati">Registra la tua attività</b-button>
              </div>
              <div class="col-4">
                <b-button variant="success" class="btn-block btn-style" to="/mappa">Cerca un'attività</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container d-block d-sm-none">
        <div class="row pt-5 pb-5">
          <div class="col-12 text-left align-self-center">
            <div class="h3">Vogliamo aiutare le aziende della nostra valle, noi ci crediamo. E tu?</div>
          </div>
          <div class="col-12">
            <div class="row mt-4">
              <div class="col-6">
                <b-button variant="dark" class="text-white btn-style" to="/registrati">Registra la tua attività</b-button>
              </div>
              <div class="col-6">
                <b-button variant="success" class="btn-block btn-style" to="/mappa">Cerca un'attività'</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
export default {};
</script>

<style scoped>
</style>
